import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as NoFilesSmall } from '../../../assets/early/svg/NoFilesSmall.svg'
import { getLastEmotions } from '../../../server/server'
import { emotions_heads_width_30 } from '../constants/Constants'
import { ANALYTICS_EVENTS } from '../../../analytics/events'
import useTrackedSurface from '../../../analytics/useTrackedSurface'
import '../../../styles/early/earlyMotion.css'

function DashboardDeeperInsight() {
    const [data, setData] = useState([])
    const { t } = useTranslation()
    useTrackedSurface(ANALYTICS_EVENTS.EARLY_DASHBOARD_DEEPER_INSIGHT_VIEWED, {
        active: data.length > 0,
        content: 'Deeper insight',
    })

    useEffect(() => {
        getData()
    }, [])

    const getData = async () => {
        const resp = await getLastEmotions()
        if (resp.status == 200) {
            setData(resp.data)
        }
    }

    return (
        <div className="flex flex-col p-[35px] bg-white rounded-[20px] h-full">
            <h2 className="text-[#5E639B] text-[24px] leading-[31px] font-bold">{t('Get Deeper Insights')}</h2>
            <p className="text-[#413F5E] text-[14px] leading-[17px] font-medium mt-2">{t('Stay up to date with student support')}</p>
            <div className="max-h-[500px] mt-[20px] overflow-y-auto">
                <div className="flex flex-col w-full em-stagger em-stagger-row">
                    {data.map((item, index) => (
                        <div
                            className="flex flex-row items-center justify-between gap-[10px] bg-transparent border-b-[1px] border-[#ECEBF8] rounded-[10px] mb-[10px] w-full min-h-[50px] py-[6px] px-[15px]"
                            key={index}
                        >
                            <div className="flex flex-col flex-1 min-w-0">
                                <p className="font-semibold text-[#5E639B] text-[18px] leading-[23px]">
                                    {item.first_name} {item.last_name}
                                </p>
                                {!!item?.message?.trim() && (
                                    <p className="text-[#413F5E] text-[14px] leading-[18px] font-medium italic truncate" title={item.message.trim()}>
                                        "{item.message.trim()}"
                                    </p>
                                )}
                            </div>
                            <div>{emotions_heads_width_30[item?.emotion]}</div>
                        </div>
                    ))}
                </div>
            </div>
            {data.length === 0 && (
                <div className="mt-[100px] w-full flex flex-col items-center gap-[25px] em-empty-in">
                    <NoFilesSmall />
                    <p className="font-semibold text-[#5E639B] text-[18px] leading-[23px]">{t('Class not selected')}</p>
                </div>
            )}
        </div>
    )
}

export default DashboardDeeperInsight
